import {
  Swiper, Lazy, Pagination, Navigation,
} from 'swiper';
import $ from 'jquery';

const swiperContainerClass = '.upcoming-events__slider';
const swipers = [];

function initSlider($slider) {
  const counts = $slider.find('.swiper-slide');
  // eslint-disable-next-line camelcase
  const slides_per_view = counts.length > 3 ? 3 : counts.length;
  const $navigation = $slider.closest('.upcoming-events__container').find('.upcoming-events__navigation');

  // eslint-disable-next-line no-new
  const swiper = new Swiper($slider[0], {
    lazy: true,
    loop: false,
    autoHeight: true,
    keyboard: {
      enabled: true,
    },
    slidesPerView: 1,
    spaceBetween: 24,
    breakpoints: {
      768: {
        slidesPerView: 2,
        autoHeight: false,
      },
      1200: {
        // eslint-disable-next-line camelcase
        slidesPerView: slides_per_view,
        spaceBetween: 40,
        autoHeight: false,
      },
    },
    modules: [Lazy, Pagination, Navigation],
    navigation: {
      nextEl: '.upcoming-events__btn--next',
      prevEl: '.upcoming-events__btn--prev',
    },
    pagination: {
      clickable: true,
      el: '.upcoming-events__pagination',
      renderBullet: (index, className) => `<button type="button" class="${className}" aria-label="Slide ${index + 1}"></button>`,
    },
    on: {
      init() {
        if (this.isBeginning && this.isEnd) {
          $navigation.hide();
        } else {
          $navigation.show();
        }
      },
      resize() {
        if (this.isBeginning && this.isEnd) {
          $navigation.hide();
        } else {
          $navigation.show();
        }
      },
    },
  });

  swipers.push(swiper);
}

function init() {
  const $boxes = $(swiperContainerClass);
  $boxes.each(function () {
    const $slider = $(this);
    initSlider($slider);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=upcoming-events', ($block) => {
      const $slider = $block.find(swiperContainerClass);
      if ($slider && $slider.length > 1) {
        initSlider($slider[0]);
      }
    });
  } else {
    init();
  }
});
